var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    fill: "url(#pattern0_771_789)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_771_789",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_771_789",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_771_789",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABoklEQVR4nO2cPU7DYBBEpyLcgRwRyDXCxQipgEMANYJ+kSVXiAL/aHfHeU+afr6n1TqRPlsCAAAAAAAAAIC/uJL0IOldUpjnTdJxPFM7jg0ExcoZztSOLUxy/MqHGhIbTTuqhQSiVS6LiVa9SFaHeqQd1ULiUkQDAAAALONa0kHSWdJ3g59b0SSDiydJ95J2Cx1rL+m1waGieV5GV7MnGcmaJHvWZB8aTEqY5W6O6HOD4mGW0xzRXw2Kh1kGZ5OpLh2mQbQQreopZKJVL47VoXqp7GghWtUTx0SrXhKrQ/UC2dHqFf6wCNGqnsJNTLQLiE4C0UkgOglEJ4HoJBCdBKKTQHQSiE4C0UkgOglEJ4HoJBC9ddFr3b1zYY2zflbeJnWh7Dbp8MoAojXJwe0c0bvxFjsTrX85eF7yaaD9CrJdWCr5ZmmB3fjKwGnmA9KFqecaXDyO6yL1I1dbFd0Om6Lu/W2Kuve3Kere36aoe3+bou79bYq697cp6t7fpqh7/9ho2lEtJBCtcllMtOpFsjrUI+2oFhKXIhoAAAAAAEBr8gPMZ9cQVEPLBgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.2cb21b3de96e3e187b220fc0642c5106.svg";
export { ForwardRef as ReactComponent };